export enum VideoType {
  None = 'none',
  CH1 = 'ch1',
  CH2 = 'ch2',
  CH3 = 'ch3',
  CH4 = 'ch4',
  CH5 = 'ch5',
  CH6 = 'ch6',
  CH7 = 'ch7',
}

const validVideoTypes: VideoType[] = [
  VideoType.CH1,
  VideoType.CH2,
  VideoType.CH3,
  VideoType.CH4,
  VideoType.CH5,
  VideoType.CH6,
  VideoType.CH7,
];

export const getVideoTypes = (): Array<VideoType> => {
  return validVideoTypes;
};

export function isVideoPost(videoType: VideoType): boolean {
  return validVideoTypes.some((type) => type === videoType);
}
